import { Box } from "@mui/material";
import { useRecoilValue } from "recoil";
import {
  courierListState,
  isCourierRegistrationExistState,
} from "../../atoms/courierRegistration";
import CourierListDeliveredItem from "./CourierListDeliveredItem";
import CourierListItem from "./CourierListItem";

const CourierList = () => {
  const isCourierRegistrationExist = useRecoilValue(
    isCourierRegistrationExistState
  );
  const courierList = useRecoilValue(courierListState);
  return (
    <Box className="courier-list">
      {courierList.length === 0 && (
        <Box className="myShipments-list-none">Kurye Kaydı bulunamadı.</Box>
      )}
      {isCourierRegistrationExist &&
        courierList.map((item, key) =>
          Number(item.status) === 3 || Number(item.status) === 4 ? (
            <CourierListDeliveredItem key={key} item={item} />
          ) : (
            <CourierListItem key={key} item={item} />
          )
        )}
    </Box>
  );
};

export default CourierList;
